export const tr = {
    'new-video': 'Yeni video'
};
